import { render, staticRenderFns } from "./EquipmentForm.vue?vue&type=template&id=2fec5643&scoped=true"
import script from "./EquipmentForm.vue?vue&type=script&lang=ts"
export * from "./EquipmentForm.vue?vue&type=script&lang=ts"
import style0 from "./EquipmentForm.vue?vue&type=style&index=0&id=2fec5643&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec5643",
  null
  
)

export default component.exports